import { Flex, Switch, Text, Tooltip } from '@modusign/design-system';
import { GetLabelListSortBy } from '@modusign/openapi-client-category/generated/model';
import { useState } from 'react';

import { LabelFilters } from '@app/features/label/types';

interface LabelListFilterProps {
  filters: LabelFilters;
  onSortByChange?: (orderBy: GetLabelListSortBy) => void;
  onBookmarkFirst?: (isBookMarkFirst: boolean) => void;
}

function LabelListFilter({ filters, onSortByChange, onBookmarkFirst }: LabelListFilterProps) {
  const [sortBy, setSortBy] = useState<'createdAt' | 'name'>('createdAt');

  return (
    <Flex alignItems="center" gap={4} justifyContent="space-between">
      <Flex alignItems="center" flex="auto" gap={2}>
        <Text color="textNeutralLight" fontSize="sm">
          정렬
        </Text>
        <Tooltip content="정렬 선택">
          <Text
            as="button"
            color="textNeutralSlightlyLight"
            fontSize="sm"
            fontWeight="medium"
            onClick={() => {
              const toggled = sortBy === 'createdAt' ? 'name' : 'createdAt';
              setSortBy(toggled);
              onSortByChange?.(toggled);
            }}
          >
            {sortBy === 'createdAt' ? '최신순' : '이름순'}
          </Text>
        </Tooltip>
      </Flex>
      <Flex alignItems="center" gap={2}>
        <Text color="textNeutralLight" fontSize="sm">
          중요 라벨 먼저
        </Text>
        <Switch
          checked={filters.bookmarkFirst}
          size="sm"
          onClick={() => {
            onBookmarkFirst?.(!filters.bookmarkFirst);
          }}
        />
      </Flex>
    </Flex>
  );
}
export default LabelListFilter;
